const details = require("./profile/details");
const changePassword = require("./profile/change_password");
const profile = () => {
  details();
  changePassword();
};

module.exports = profile;
